import type { Getter, Setter } from 'jotai';
import type { UndoRedoActionCommand } from '../../../../../modernization-common/undo-redo/types';
import { STUDIO_WRITE_ACTIONS } from '../../studio-store-write/actions';
import { dispatchStudioStoreWriteAtom } from '../../studio-store-write/dispatch-studio-store-write';
import type { BulkAddAnnotationsEventPayload } from '../events';
export const bulkAddAnnotationsCommandFactory = (_get: Getter, set: Setter): UndoRedoActionCommand<BulkAddAnnotationsEventPayload, void> => {
  return {
    execute: payload => {
      const {
        annotations
      } = payload;
      set(dispatchStudioStoreWriteAtom, {
        type: STUDIO_WRITE_ACTIONS.BULK_WRITE,
        writes: annotations.flatMap(({
          frameIndex,
          annotations: frameAnnotations
        }) => frameAnnotations.map(({
          id,
          annotation
        }) => ({
          frameIndex,
          annotationId: id,
          annotation: {
            ...annotation,
            metadata: {
              ...annotation.metadata,
              annotationSource: undefined
            }
          }
        })))
      });
    },
    undo: payload => {
      const {
        annotations
      } = payload;
      set(dispatchStudioStoreWriteAtom, {
        type: STUDIO_WRITE_ACTIONS.BULK_DELETE,
        deletes: annotations.flatMap(({
          frameIndex,
          annotations: frameAnnotations
        }) => frameAnnotations.map(({
          id
        }) => ({
          frameIndex,
          annotationId: id
        })))
      });
    }
  };
};